import React from "react";

const Header = () => {
    return (
        <div>
            <div className="code">
                <a
                    className="code"
                    href="https://github.com/jljonnard/tripfindr"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Consulter le code de l'application sur GitHub
                </a>
            </div>
            <div id="banner">
                <h1>Trip Findr</h1>
            </div>
        </div>
    );
};

export default Header;
